import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, HelperService, MyTeamsService } from '../../../services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StorageUtil } from '../../../models';
import { sortBy } from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-add-practice',
  templateUrl: './add-practice.component.html',
  styleUrls: ['./add-practice.component.css']
})
export class AddPracticeComponent implements OnInit {
  @Input() team;

  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();

  isHeadUpDisplay: boolean = false;

  EditForm: FormGroup;

  startTime: string;
  endTime: string;
  errorInStartTime = false;
  errorInEndTime = false;
  amORpmStartTime: string = "AM";
  amORpmEndTime: string = "AM";
  venueId: number = 0;
  venueName: string;
  practiceID: number = 0;
  practiceId: number = 0;
  repeatData: string;
  invitedPlayerList: any = [];
  complexAndVanue: any[] = [];
  isDisplay: boolean;

  constructor(
    private fb: FormBuilder,
    private service: MyTeamsService,
    private loader: Ng4LoadingSpinnerService,
    private helperService: HelperService,
    private alertService: AlertService,
  ) {
    this.EditForm = this.fb.group({
      StartTime: ['', Validators.required],
      EndTime: ['', Validators.required],
      StartTimeAMPM: [''],
      EndTimeAMPM: [''],
      Title: [''],
      Notes: [''],
      LocationOfPractice: [''],
      DateOfPractice: ['', Validators.required],
      teamAdmins: ['']
    });
  }

  ngOnInit() {
    this.service.getTeamPlayerListByTeamID(StorageUtil.teamId).subscribe((rs: any) => {
      if (rs) {
        this.invitedPlayerList = sortBy(rs.map(s => ({ ...s, name: s.lastName + ', ' + s.firstName })), 'name');
        this.EditForm.patchValue({
          teamAdmins: this.invitedPlayerList.map(u => u.userID)
        })
      }
    });

    this.service.getComplexVenueByClubID(StorageUtil.clubID).subscribe((rs: any) => {
      if (rs) {
        this.complexAndVanue = rs;
      }
    }, (error) => {
      console.log(error.error);
    });
  }

  closeEditOverlay() {
    this.EditForm.reset();
    this.cancel.emit();
  }

  fillTime(time, isStartTime) {
    //Get Hours and Minutes from Selected Time
    var hours = time.toString().substring(0, 2);
    var min = time.toString().substring(3, 5);

    if (+hours > 12 || +min > 59) { //Show error if invalid hours and minutes input
      //check if adding new venue availability is there
      if (isStartTime) {
        this.errorInStartTime = true;
      }
      else {
        this.errorInEndTime = true;
      }

    }
    else { //Valid hours and minutes
      if (isStartTime) {
        this.startTime = time;
        this.errorInStartTime = false;
      }
      else {
        this.endTime = time;
        this.errorInEndTime = false;
      }
    }
  }

  onAMPMChange(amORpm, isStartTime) {
    if (isStartTime) {
      this.amORpmStartTime = amORpm;
    }
    else {
      this.amORpmEndTime = amORpm;
    }
  }

  onLocationChange(e) {
    this.venueId = + e.target.options[e.target.selectedIndex].value;
    this.venueName = e.target.options[e.target.selectedIndex].text;
  }

  onRepeatChange(event) {
    this.repeatData = event.value;
  }

  addOrEdit() {
    var startTime: string = this.formatTimeWithAMPM(this.startTime, this.amORpmStartTime);
    var endTime: string = this.formatTimeWithAMPM(this.endTime, this.amORpmEndTime);
    if (startTime == "error" || endTime == "error") {
      if (endTime == "error") {
        this.errorInEndTime = true;
      }
      else {
        this.errorInStartTime = true;
      }

      this.helperService.alertMessage('warn', 'Heads Up!', 'Please Enter Valid Time!');
      return;
    }
    let InvitedPlayerList = [];
    let tempteamAdmins = this.EditForm.value.teamAdmins;

    this.invitedPlayerList.map(x => {
      tempteamAdmins.map(y => {
        if (x.userID == y) {
          InvitedPlayerList.push(
            {
              PlayerID: x.userID,
              PlayerFirstName: x.firstName,
              PlayerLastName: x.lastName,
              PlayerEmail: x.email,
            }
          );
          //  break;
        }
      });
    });
    let obj = {
      "TeamId": this.team.teamID,
      "ClubId": 0,
      "TeamName": this.team.teamName,
      "ClubLogo": '',
      "PracticeId": this.practiceId,
      "PracticeDate": moment(this.EditForm.value.DateOfPractice).format('YYYY-MM-DD'),
      "StartTime": startTime,
      "EndTime": endTime,
      "VenueId": this.venueId,
      "VenueName": this.venueName,
      "Repeat": this.repeatData,
      "Note": this.EditForm.value.Notes,
      "AddedBy": StorageUtil.userID,
      "InvitedPlayerList": InvitedPlayerList
    }
    this.loader.show();
    //this.service.addOrEditPracticeToTeamOrClub(obj).subscribe((rs: any) => {
    this.service.addOrEditPracticeToTeamOrClubNew(obj).subscribe((rs: any) => {
      this.loader.hide();
      this.EditForm.reset();
      this.save.emit();
    }, (error) => {
      this.loader.hide();
      this.closeEditOverlay();
      this.alertService.error(error.error);
      console.log(error.error);
    });
  }

  formatTimeWithAMPM(time, amORpm) {
    var hours = time.toString().substring(0, 2);
    var min = time.toString().substring(3, 5);

    var timeORmessage = "";

    if (+hours == 0) {
      return "error";
    }
    else if (amORpm == "AM") {
      timeORmessage = +hours + ":" + min;
    }
    else if (amORpm == "PM" && +hours != 12) { //Check if PM is selected then add 12 to Hours
      hours = +hours + 12;
      timeORmessage = +hours + ":" + min;
    } else if (amORpm == "PM" && +hours == 12) { //Check if PM is selected then add 12 to Hours
      //hours = +hours;
      timeORmessage = +hours + ":" + min;
    }

    //Only Valid Time should allowed
    if (+hours == 12 && +min >= 0 && amORpm == "AM") {
      timeORmessage = "error";
    } else if (+hours == 0 && +min >= 0 && amORpm == "PM") {
      timeORmessage = "error";
    }

    //console.log("timeORmessage =>", timeORmessage);
    return timeORmessage;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/add-practice/add-practice.component.ts